import { render, staticRenderFns } from "./QuickLabelAddressList.vue?vue&type=template&id=1e415971&scoped=true&"
import script from "./QuickLabelAddressList.vue?vue&type=script&lang=js&"
export * from "./QuickLabelAddressList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e415971",
  null
  
)

export default component.exports